import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  postNotifications,
  type CreateNotificationRequest,
} from "Infrastructure/Api/Api";
import { notificationsKeys } from "Api/Queries/Notifications/useNotifications";
import { allAdminNotificationsKeys } from "Api/Queries/Notifications/useAllNotifications";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hooks.Notifications;

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useCreateNotificationMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: CreateNotificationRequest) => postNotifications(data),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationsKeys.all });
      queryClient.invalidateQueries({
        queryKey: allAdminNotificationsKeys.all,
      });
      toast.success(t(RESOURCES.Created));
      onSuccess?.();
    },
    onError: (error) => {
      toast.error(t(RESOURCES.CreateError));
      onError?.(error);
    },
  });
};
